import React from "react";
import { Alert } from "react-bootstrap";
import { useNotification } from "./NotificationContext";

const Notification = () => {
    const { notification } = useNotification();

    if (!notification.message) return null;

    const variant = notification.type === "success" ? "success" : "danger";

    return (
        <div style={{ position: "fixed", top: "20px", right: "20px", zIndex: 1000 }}>
            <Alert variant={variant} dismissible>
                {notification.message}
            </Alert>
        </div>
    );
};

export default Notification;
